<!-- TODO:// Need to remove comment when we start handling authentication at our end -->
<!-- <router-outlet *ngIf="!isError; else elseBlock"></router-outlet>

<ng-template #elseBlock>
  <smarsh-app-error></smarsh-app-error>
</ng-template> -->

<router-outlet></router-outlet>
